import { stringify } from "query-string";

import useFilteredQueryParams from "./useFilteredQueryParams";

const useFilteredQueryString = (keepContinue = false): string => {
  const params = useFilteredQueryParams(keepContinue);
  return `?${stringify(params)}`;
};

export default useFilteredQueryString;
